<template>
  <a-locale-provider :locale="locale">
    <div class="mod-flight-status container">
      <div class="tab">
        <a-tabs v-model="tabInit" type="card">
          <a-tab-pane tab="按航班号" key="1">
            <div class="search-bar clearfix">
              <a-form layout="vertical">
                <a-form-item label="航班号" class="item">
                  <a-input v-model.trim="flightNo" size="large" placeholder="航班号" />
                </a-form-item>
                <a-form-item label="航班日期" class="item">
                  <air-calendar v-model="flightDate" :beginTime="beginDate" :showLoading="true" placeholder="航班日期"
                    placement="bottomRight"></air-calendar>
                </a-form-item>
              </a-form>
              <a-button class="btn" type="primary" @click="onFlightNoSearch">
                查询
              </a-button>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="按城市名" key="2">
            <div class="search-bar clearfix">
              <a-form layout="vertical">
                <a-form-item label="出发地" class="item city">
                  <air-flight-city-selector placeholder="城市名称" :data-source="cities" v-model="orgCity"
                    placement="bottomRight"></air-flight-city-selector>
                </a-form-item>
                <a-form-item label="目的地" class="item city">
                  <air-flight-city-selector placeholder="城市名称" :data-source="cities" v-model="dstCity"
                    placement="bottomRight"></air-flight-city-selector>
                </a-form-item>
                <a-form-item label="航班日期" class="item">
                  <air-calendar v-model="flightDate" :beginTime="beginDate" :showLoading="true" placeholder="航班日期"
                    placement="bottomRight"></air-calendar>
                </a-form-item>
              </a-form>
              <a-button class="btn" type="primary" @click="onCitySearch">
                查询
              </a-button>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="table">
        <a-table :columns="columns" :rowKey="record => `${record.flightNo}-${record.staChn}`" :dataSource="data"
          :pagination="pagination" :loading="loading" :locale="{
            emptyText: '暂无数据'
          }" :expandedRowKeys="expandedRowKeys" :expandIconColumnIndex="-1" :expandIconAsCell='false'
          @change="handleTableChange">
          <span class="flight-no" slot="flightNo" slot-scope="record">
            <div :class="['airline-logo-pure', 'logo', `logo-${record.flightNo.slice(0, 2).toLocaleLowerCase()}`]"></div>
            {{ record.flightNo }}
          </span>
          <span slot="toimg">
            <img src="./image/to.png" alt="">
          </span>
          <span slot="arrStn" slot-scope="record">
            <span> {{ record.arrStn }} </span>
          </span>
          <span slot="startTime" slot-scope="record">
            <p>计划{{ record | gtLocal }}：<span>{{ record.stdChn | gtTime }}</span></p>
            <p v-if="record.ataChn">实际{{ record | gtLocal }}：<span>{{ record.atdChn | gtTime }}</span></p>
            <p v-else>预计{{ record | gtLocal }}：<span>{{ record.etdChn | gtTime }}</span></p>
          </span>
          <span slot="endTime" slot-scope="record">
            <p>计划{{ record | gtLocal }}：<span class="right-city">{{ record.staChn | gtTime }}</span></p>
            <p v-if="record.ataChn">实际{{ record | gtLocal }}：<span class="right-city">{{ record.ataChn | gtTime }}</span>
            </p>
            <p v-else>预计{{ record | gtLocal }}：<span class="right-city">{{ record.etaChn | gtTime }}</span></p>

          </span>
          <span slot="status" slot-scope="record">
            <span v-html="record.status"></span>
            <template v-if="record.divRecode === 'Y'">
              <a-tooltip slot="addonAfter" placement="right" overlayClassName="uni-tooltip">
                <template slot="title">
                  <div>{{ record.divRecodeCnName }}</div>
                  <div>{{ record.divRecodeReasonDetail }}</div>
                </template>
                <template v-if="record.divRecodeCnName && record.divRecodeReasonDetail">
                  <span class="div-recode">
                    (备降) <a-icon class="tooltip" type="info-circle"></a-icon>
                  </span>
                </template>
              </a-tooltip>
            </template>
          </span>
          <span class="roundtrip-line" slot="expandedRowRender" slot-scope="record">
            <div>
              <span> 经停：{{
                record.arrStn }} </span>
            </div>
          </span>
        </a-table>
      </div>
      <div class="mod-tip" >
        <p class="tips-info" v-if="flightStatusTips" v-html="flightStatusTips"></p>
        <template v-else>
          <a-icon type="exclamation-circle" theme="filled" /> 温馨提示：以上航班动态仅供参考，如您的行程发生变动，实际请以{{ airlineName }}官方取消短信为准。
        </template>
      </div>
    </div>
  </a-locale-provider>
</template>

<script>
import moment from 'moment'
import { schedule } from '@/apis/service'
import getAppInfo from '@/utils/from'
import { flightCities } from '@/assets/js/data'
import { getDaySpan } from '@/filters/time'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import './index'
import _ from 'lodash'

const columns = [

  {
    title: '航班号',
    scopedSlots: { customRender: 'flightNo' },
    align: 'center',
    width: '156px'
  },
  {
    title: '出发城市',
    dataIndex: 'depStn',
    align: 'center'

  },
  {
    title: '',
    scopedSlots: { customRender: 'toimg' },
    align: 'center',
    width: '78px'
  },
  {
    title: '到达城市',
    scopedSlots: { customRender: 'arrStn' },
    align: 'center'

  },
  {
    title: '起飞时间',
    scopedSlots: { customRender: 'startTime' },
    align: 'center'
  },
  {
    title: '到达时间',
    scopedSlots: { customRender: 'endTime' },
    align: 'center'
  },
  {
    title: '航班状态',
    scopedSlots: { customRender: 'status' },
    align: 'center'
  }
]
const flightNoReg = /^[A-Za-z0-9]{6}$/

const airlineName = getAppInfo()?.name

export default {
  data () {
    return {
      data: [],
      expandedRowKeys: [],
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0
      },
      loading: false,
      columns,
      tabInit: '1',
      flightDate: moment(),
      beginDate: moment(new Date('1990-01-01')), // TODO: 临时设置，需更新组件API
      flightNo: '',
      orgCity: '',
      dstCity: '',
      airlineName: airlineName,
      cities: [],
      locale: zhCN,
      flightStatusTips: ''
    }
  },
  filters: {
    getDaySpan
  },
  mounted () {
    const params = (new URL(location.href)).searchParams
    const flightDate = params.get('flightDate')
    const flightNo = params.get('flightNo')
    const orgCity = params.get('orgCity')
    const dstCity = params.get('dstCity')
    this.getData()
    this.getCmsData()

    if (flightDate) {
      this.flightDate = moment(flightDate)
    }

    if (orgCity && dstCity) {
      this.orgCity = orgCity
      this.dstCity = dstCity
      this.tabInit = '2'

      this.$nextTick(() => {
        this.onCitySearch()
      })

      return
    }

    if (flightNo) {
      this.flightNo = flightNo

      this.$nextTick(() => {
        this.onFlightNoSearch()
      })
    }

    // 兼容通用版各家航司，不主动进行查询
    // const { pagination } = this

    // this.fetch({
    //   flightDate: this.flightDate,
    //   page: pagination.current,
    //   pageSize: pagination.pageSize
    // })
  },
  methods: {
    async getData () {
      const cities = await flightCities()

      if (cities) {
        this.cities = cities
      }
    },
    async getCmsData () {
      const pageCmsData = this.pageCmsData = (await window.__MICRO_ROOT__?.cms?.getPageData()) ?? {}
      this.flightStatusTips = _.get(pageCmsData, 'flight-status-tips.content') || ''
    },
    handleTableChange (pagination) {
      this.fetch({
        ...this.params,
        page: pagination.current,
        pageSize: pagination.pageSize
      })
    },
    async fetch (params = {}) {
      this.loading = true
      this.params = params

      try {
        const { currentPageNumber, totalResultCount, list = [] } = await schedule(this.params)
        this.loading = false
        this.expandedRowKeys = list.map((item) => {
          if (item.isStop) {
            return `${item.flightNo}-${item.staChn}`
          }
        })
        this.data = list
        this.pagination.current = currentPageNumber
        this.pagination.total = totalResultCount
      } catch (err) {
        this.loading = false
        this.$message.error(err.message || '网络异常，请稍后再试！')
      }
    },

    onFlightNoSearch () {
      const { flightNo, flightDate } = this
      if (!flightNo) {
        this.$message.error('航班号不能为空！')
        return
      }

      if (flightNo && !flightNoReg.test(flightNo)) {
        this.$message.error('航班号输入错误！')
        return
      }

      if (!flightDate) {
        this.$message.error('航班日期不能为空！')
        return
      }

      this.pagination = {
        current: 1,
        pageSize: 20,
        total: 0
      }

      this.$nextTick(() => {
        this.fetch({
          flightNo,
          flightDate,
          page: 1,
          pageSize: 20
        })
      })
    },
    onCitySearch () {
      const { orgCity, dstCity, flightDate } = this

      if (!orgCity) {
        this.$message.error('出发地不能为空！')
        return
      }

      if (!dstCity) {
        this.$message.error('目的地不能为空！')
        return
      }

      if (!flightDate) {
        this.$message.error('航班日期不能为空！')
        return
      }

      this.pagination = {
        current: 1,
        pageSize: 20,
        total: 0
      }

      this.$nextTick(() => {
        this.fetch({
          orgCity: dstCity,
          dstCity: orgCity,
          flightDate,
          page: 1,
          pageSize: 20
        })
      })
    }
  }
}
</script>
